import { ApiService } from '../_services/ApiService';

export class ProxyCorsService extends ApiService {
    protected basePath = 'utils/cors';
    protected subPaths = {};

    public getCorsUrlProxy(url: string): string {
        return this.getQueryUrlRequest({ url });
    }
}



// WEBPACK FOOTER //
// ./src/Services/CorsService.ts